import { render, staticRenderFns } from "./ArticleShow.vue?vue&type=template&id=e2a72a52&scoped=true&"
import script from "./ArticleShow.vue?vue&type=script&lang=js&"
export * from "./ArticleShow.vue?vue&type=script&lang=js&"
import style0 from "./ArticleShow.vue?vue&type=style&index=0&id=e2a72a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a72a52",
  null
  
)

component.options.__file = "ArticleShow.vue"
export default component.exports